import { useTranslation } from 'react-i18next';
import i18n from '../i18n/config';
import React from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Paper,
  useTheme
} from '@mui/material';
import {
  Home as HomeIcon,
  ArrowBack as BackIcon,
  Search as SearchIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import ArsenalLogo from '../components/common/ArsenalLogo';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 4,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 4,
            maxWidth: 500,
            width: '100%',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 3,
          }}
        >
          {/* Logo */}
          <ArsenalLogo
            sx={{
              width: 80,
              height: 80,
              color: theme.palette.primary.main,
              mb: 3,
            }}
          />

          {/* 404 Text */}
          <Typography
            variant="h1"
            sx={{
              fontSize: '6rem',
              fontWeight: 700,
              color: theme.palette.primary.main,
              lineHeight: 1,
              mb: 2,
            }}
          >
            404
          </Typography>

          {/* Main Message */}
          <Typography
            variant="h4"
            component="h1"
            fontWeight={600}
            color="text.primary"
            gutterBottom
          >
            {i18n.t('hardcoded.pages_notfoundpage.page_not_found')}</Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            paragraph
            sx={{ mb: 4 }}
          >
            {i18n.t('hardcoded.pages_notfoundpage.page_not_found_description')}
          </Typography>

          {/* Action Buttons */}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              flexWrap: 'wrap',
              mb: 3,
            }}
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={handleGoHome}
            >
              {i18n.t('hardcoded.pages_notfoundpage.go_to_dashboard')}</Button>

            <Button
              variant="outlined"
              size="large"
              startIcon={<BackIcon />}
              onClick={handleGoBack}
            >
              {i18n.t('hardcoded.pages_notfoundpage.go_back')}
            </Button>
          </Box>

          {/* Search Suggestion */}
          <Box
            sx={{
              mt: 3,
              pt: 3,
              borderTop: '1px solid',
              borderTopColor: 'divider',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
              <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                {i18n.t('hardcoded.pages_notfoundpage.try_searching')}
              </Typography>
            </Box>
            
            <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                size="small"
                variant="text"
                onClick={() => navigate('/vehicles')}
              >
                {i18n.t('hardcoded.pages_helppage.vehicles')}</Button>
              <Button
                size="small"
                variant="text"
                onClick={() => navigate('/sensors')}
              >
                {i18n.t('hardcoded.contexts_tutorialcontext.sensors')}</Button>
              <Button
                size="small"
                variant="text"
                onClick={() => navigate('/telemetry')}
              >
                {i18n.t('hardcoded.pages_helppage.telemetry')}</Button>
              <Button
                size="small"
                variant="text"
                onClick={() => navigate('/alarms')}
              >
                {i18n.t('hardcoded.pages_helppage.alarms')}</Button>
            </Box>
          </Box>
        </Paper>

        {/* Footer */}
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="caption" color="text.secondary">
            {i18n.t('hardcoded.pages_notfoundpage.contact_support_message')}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFoundPage;